module.exports = __webpack_public_path__ + "img/xPequeño.18fd8599.svg";